/**
 * Rechtliche Inhalte · editierbar über Admin (Keys: legal.impressum, legal.datenschutz, legal.bdv_kontakt).
 *
 * IMPRESSUM_DEFAULT, DATENSCHUTZ_DEFAULT und BDV_KONTAKT_DEFAULT sind die 1:1
 * von www.b-d-v.de übernommenen Texte (Stand: 12. Januar 2026, extrahiert am 24. Juli 2026).
 * Auf ausdrücklichen Wunsch des Nutzers: kein einziger Buchstabe gekürzt, hinzugefügt oder umformuliert.
 *
 * Rechtliche Prüfung vor Livegang bleibt Aufgabe der BDV GmbH.
 */
import { BDV_CONTACT } from "@/lib/homeContent";

/* ─── 1:1 Markdown-Defaults, wörtlich von www.b-d-v.de ─────────────────── */

export const IMPRESSUM_DEFAULT = `# Impressum

Angaben gemäß § 5 TMG

## Anbieter

BDV Büroservice Dienstleistungs- Vermittlungs GmbH

Grafenberger Allee 293

40237 Düsseldorf

Deutschland

## Vertreten durch

Geschäftsführer: Gerhard Kirchner

## Kontakt

Telefon: 0211-61 66 33 00

Telefax: 0211-61 66 33 20

E-Mail: info@hypefly.de

## Registereintrag

Handelsregister: HRB 49554

Registergericht: Amtsgericht Düsseldorf

## Umsatzsteuer-Identifikationsnummer

USt-IdNr. gemäß § 27a UStG: DE234734289

## Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV

Gerhard Kirchner · Grafenberger Allee 293 · 40237 Düsseldorf

## Streitschlichtung

Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung bereit: [ec.europa.eu/consumers/odr](https://ec.europa.eu/consumers/odr). Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.

## Haftung & Urheberrecht

Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte verantwortlich. Inhalte und Werke unterliegen dem deutschen Urheberrecht. Vervielfältigung, Bearbeitung und Verwertung außerhalb der Grenzen des Urheberrechts bedürfen schriftlicher Zustimmung. Für externe Links übernehmen wir keine Haftung.
`;

export const DATENSCHUTZ_DEFAULT = `# Datenschutzerklärung

Stand: Montag, 12. Januar 2026

## 1. Verantwortlicher

Verantwortlicher i.S.d. DSGVO ist:

BDV Büroservice Dienstleistungs- Vermittlungs GmbH

Grafenberger Allee 293, 40237 Düsseldorf

Geschäftsführer: Gerhard Kirchner

Telefon: 0211-61 66 33 00 · E-Mail: info@hypefly.de

## 2. Allgemeine Hinweise

Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist.

## 3. Rechtsgrundlagen

Soweit eine Einwilligung eingeholt wird, dient Art. 6 Abs. 1 lit. a DSGVO als Rechtsgrundlage. Für vorvertragliche bzw. vertragliche Maßnahmen Art. 6 Abs. 1 lit. b DSGVO; bei rechtlichen Verpflichtungen Art. 6 Abs. 1 lit. c DSGVO; bei berechtigten Interessen Art. 6 Abs. 1 lit. f DSGVO.

## 4. Hosting & Server-Logfiles

Diese Website wird auf Servern eines deutschen Webhosters betrieben. Technisch notwendige Daten (IP-Adresse, Datum/Uhrzeit, abgerufene Datei, Referrer, Browser, OS) werden in Server-Logfiles verarbeitet — Rechtsgrundlage Art. 6 Abs. 1 lit. f DSGVO. Löschung nach spätestens 14 Tagen.

## 5. Kontaktformular und E-Mail-Anfragen

Bei Nutzung unseres Kontaktformulars werden Name, ggf. Firma, E-Mail-Adresse, ggf. Telefon, Anliegen und Nachricht zur Bearbeitung Ihrer Anfrage erhoben.

Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO, Art. 6 Abs. 1 lit. a DSGVO (Einwilligung via Checkbox) und/oder Art. 6 Abs. 1 lit. f DSGVO.

### Formulardienstleister „Web3Forms"

Zur technischen Übermittlung des Formulars setzen wir Web3Forms ein (Anbieter mit Sitz außerhalb der EU/EWR). Beim Absenden werden die Daten an Server von Web3Forms übertragen. Web3Forms speichert die Inhalte laut Anbieter nicht dauerhaft, sondern leitet sie unmittelbar als E-Mail an unsere Adresse weiter. Aktuelle Anbieterinformationen: [web3forms.com/privacy](https://web3forms.com/privacy). Rechtsgrundlage Drittlandübermittlung: Art. 49 Abs. 1 lit. a DSGVO (Ihre Einwilligung über die Datenschutz-Checkbox).

## 6. Cookies

Diese Website verwendet keine Tracking- oder Marketing-Cookies. Es werden ausschließlich technisch notwendige Cookies eingesetzt, sofern für den Betrieb erforderlich.

## 7. Google Fonts

Zur einheitlichen Darstellung von Schriftarten lädt diese Website Web-Fonts (Cormorant Garamond & Jost) von Google Fonts. Beim Aufruf der Website wird Ihre IP-Adresse an Google übertragen. Rechtsgrundlage: berechtigtes Interesse an einer ansprechenden Darstellung nach Art. 6 Abs. 1 lit. f DSGVO. Datenschutzhinweise von Google: [policies.google.com/privacy](https://policies.google.com/privacy).

## 8. SSL-/TLS-Verschlüsselung

Diese Seite nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie am Schloss-Symbol im Browser.

## 9. Rechte der betroffenen Personen

- Auskunft (Art. 15 DSGVO)
- Berichtigung oder Löschung (Art. 16, 17 DSGVO)
- Einschränkung der Verarbeitung (Art. 18 DSGVO)
- Widerspruch (Art. 21 DSGVO)
- Datenübertragbarkeit (Art. 20 DSGVO)
- Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)

Sie haben außerdem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren (Art. 77 DSGVO). Zuständig: Landesbeauftragte für Datenschutz und Informationsfreiheit NRW.

## 10. Aktualität und Änderung

Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht.
`;

export const BDV_KONTAKT_DEFAULT = `# Wir freuen uns auf Ihre Nachricht.

_Kontakt_

Schreiben Sie uns über das Formular oder erreichen Sie uns direkt per Telefon oder E-Mail. Wir melden uns zeitnah bei Ihnen zurück.

## Hauptsitz

**Düsseldorf**

BDV Büroservice Dienstleistungs- Vermittlungs GmbH  
Grafenberger Allee 293  
40237 Düsseldorf

## Telefon & Fax

[0211-61 66 33 00](tel:+4921161663300)  
Fax: 0211-61 66 33 20

## E-Mail

[info@hypefly.de](mailto:info@hypefly.de)
`;

/* ─── Legacy-Struktur (Alt-Fallback für vorhandene section-based Rendering) ─
 * Wird nur noch aktiv, falls der Markdown-Wert im CMS gelöscht wurde UND die
 * Default-Konstante ebenfalls leer wäre. Wortlaut bleibt für Reversibilität.
 */

export const IMPRESSUM = {
    title: "Impressum",
    intro: "Angaben gemäß § 5 TMG",
    sections: [
        {
            heading: "Anbieter",
            body: [
                BDV_CONTACT.company,
                `${BDV_CONTACT.street}`,
                `${BDV_CONTACT.zip} ${BDV_CONTACT.city}`,
                "Deutschland",
            ],
        },
        {
            heading: "Vertreten durch",
            body: [`Geschäftsführer: ${BDV_CONTACT.ceo}`],
        },
        {
            heading: "Kontakt",
            body: [
                `Telefon: ${BDV_CONTACT.phone}`,
                `Telefax: ${BDV_CONTACT.fax}`,
                `E-Mail: ${BDV_CONTACT.email}`,
            ],
        },
    ],
};

export const DATENSCHUTZ = {
    title: "Datenschutzerklärung",
    intro: "Stand: Montag, 12. Januar 2026",
    sections: [
        {
            heading: "1. Verantwortlicher",
            body: [
                `Verantwortlicher i.S.d. DSGVO ist ${BDV_CONTACT.company}, ${BDV_CONTACT.street}, ${BDV_CONTACT.zip} ${BDV_CONTACT.city}. Geschäftsführer: ${BDV_CONTACT.ceo}.`,
            ],
        },
    ],
};

export const BDV_KONTAKT = {
    title: "Wir freuen uns auf Ihre Nachricht.",
    intro: "Kontakt",
};
